import { COMMENT_TRUNCATE_LEN_SHORT, truncateString } from '@/helpers';
import { MediaCreatedMessage } from '@/queries/community-feed/types';
import { trackMP } from '@/shared/mp';

import Card, { CardProps } from './Card';
import { CardHabitatLink } from './CardLink';
import { getMediaQueryParams } from './utils';

const MediaCreatedCard = ({ messageWithMeta }: CardProps<MediaCreatedMessage>) => {
  const { message } = messageWithMeta;
  const mediaType = 'media' in message ? message.media.type : message.mediaType;
  return (
    <Card messageWithMeta={messageWithMeta}>
      {'media' in message && (
        <div className="inline-flex w-full gap-2 pt-2">
          <CardHabitatLink
            message={message}
            query={getMediaQueryParams(message)}
            className="flex-none"
            onClick={() => {
              trackMP('community-feed-clicked', {
                content: 'media',
              });
            }}
          >
            <img
              className="preflight preflight-img aspect-video h-14 w-auto overflow-hidden rounded"
              src={message.media.previewURL}
              alt="text"
              onContextMenu={(e) => e.preventDefault()}
            />
          </CardHabitatLink>
          <p className="preflight preflight-p line-clamp-3 min-w-0 shrink overflow-hidden break-words text-left text-xs">
            &quot;
            <CardHabitatLink
              message={message}
              query={getMediaQueryParams(message)}
              onClick={() => {
                trackMP('community-feed-clicked', {
                  content: 'media-title',
                });
              }}
            >
              {truncateString(message.media.title, COMMENT_TRUNCATE_LEN_SHORT)}
            </CardHabitatLink>
            &quot; a {mediaType === 'video' ? 'clip' : 'photo'} was taken of the{' '}
            <CardHabitatLink
              message={message}
              onClick={() => {
                trackMP('community-feed-clicked', {
                  content: 'habitat',
                });
              }}
            >
              {truncateString(messageWithMeta.message.habitat.title, COMMENT_TRUNCATE_LEN_SHORT)}
            </CardHabitatLink>
          </p>
        </div>
      )}
    </Card>
  );
};

export default MediaCreatedCard;
